// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"036f67ed","261":"2205aef2","338":"02d6b28a","456":"fcea71d2","541":"c54f9720","544":"963bef01","576":"d83c7e08","753":"15f09933","775":"a5a5ba04","823":"cf71f471"}[chunkId] + ".js";
};